module.exports = __webpack_public_path__ + "img/top_option-2.b8561550.png";